import React, { useState, useRef, useEffect } from "react";
import { useParams } from "react-router-dom";
import {
  postPinCode,
  postCreateProfile,
  userLoginWithSecret,
} from "../../services/api";
import { motion, AnimatePresence } from "framer-motion";
import { MdCalendarToday, MdAccessTime } from "react-icons/md";
import Header from "../header";
import Notiflix from "notiflix";
import { useNavigate } from "react-router-dom";
import DatePicker, { registerLocale } from "react-datepicker";
import tr from "date-fns/locale/tr";
// Import DatePicker styles
import "react-datepicker/dist/react-datepicker.css";
import { setCookie } from "../../services/cookies";
import { getCurrentPackageUser } from "../../services/api";

// Türkçe locale'i kaydet
registerLocale("tr", tr);

export default function NewAccount({ data }) {
  const { id: uuid } = useParams();
  const [screen, setScreen] = useState(1);
  const [selectedModule, setSelectedModule] = useState(null);
  const [verificationCode, setVerificationCode] = useState("");
  const navigate = useNavigate();
  const [isVerifying, setIsVerifying] = useState(false);
  const [verifyError, setVerifyError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitError, setSubmitError] = useState("");
  const [locationSearch, setLocationSearch] = useState("");
  const [locationResults, setLocationResults] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [isSearchingLocation, setIsSearchingLocation] = useState(false);
  const [showGenderDropdown, setShowGenderDropdown] = useState(false);
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [showTimePicker, setShowTimePicker] = useState(false);
  const [selectedDate, setSelectedDate] = useState(null);
  const [selectedTime, setSelectedTime] = useState(null);
  const [formData, setFormData] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    birthDate: "",
    birthTime: "",
    birthPlace: "",
    gender: "Erkek",
    secretKey: "",
  });

  // Random 10 haneli string oluşturma fonksiyonu
  const generateRandomPassword = () => {
    const chars =
      "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789";
    let result = "";
    for (let i = 0; i < 10; i++) {
      result += chars.charAt(Math.floor(Math.random() * chars.length));
    }
    return result;
  };
  const searchTimeoutRef = useRef(null);
  const genderDropdownRef = useRef(null);
  const datePickerRef = useRef(null);
  const timePickerRef = useRef(null);

  const fetchData = async () => {
    const data = await getCurrentPackageUser(uuid);
    if (data.role !== "ROOKIE" || data.current_package !== 11) {
      navigate("/" + uuid);
    }
  };

  useEffect(() => {
    fetchData();
  }, [uuid]);
  // Notiflix'i initialize et
  React.useEffect(() => {
    Notiflix.Notify.init({
      position: "top-right",
      timeout: 3000,
      clickToClose: true,
      pauseOnHover: true,
    });
  }, []);

  // Component unmount olduğunda timeout'u temizle
  React.useEffect(() => {
    return () => {
      if (searchTimeoutRef.current) {
        clearTimeout(searchTimeoutRef.current);
      }
    };
  }, []);

  // Dropdown'ları dışarı tıklandığında kapat
  React.useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        genderDropdownRef.current &&
        !genderDropdownRef.current.contains(event.target)
      ) {
        setShowGenderDropdown(false);
      }
      if (
        datePickerRef.current &&
        !datePickerRef.current.contains(event.target)
      ) {
        setShowDatePicker(false);
      }
      if (
        timePickerRef.current &&
        !timePickerRef.current.contains(event.target)
      ) {
        setShowTimePicker(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const handlePinChange = (e) => {
    const value = e.target.value.replace(/\D/g, ""); // Sadece rakamları al
    if (value.length <= 6) {
      setVerificationCode(value);
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  // Doğum tarihi maskeleme (GG-AA-YYYY formatı)
  const handleBirthDateChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Sadece rakamları al

    if (value.length >= 2) {
      value = value.substring(0, 2) + "-" + value.substring(2);
    }
    if (value.length >= 5) {
      value = value.substring(0, 5) + "-" + value.substring(5, 9);
    }

    setFormData((prev) => ({
      ...prev,
      birthDate: value,
    }));
  };

  // Doğum saati maskeleme
  const handleBirthTimeChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Sadece rakamları al

    if (value.length >= 2) {
      value = value.substring(0, 2) + ":" + value.substring(2, 4);
    }

    setFormData((prev) => ({
      ...prev,
      birthTime: value,
    }));
  };

  // Secret key maskeleme - 4 haneli sayısal kod
  const handleSecretKeyChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Sadece rakamları al

    // Maksimum 4 hane
    if (value.length > 4) {
      value = value.substring(0, 4);
    }

    setFormData((prev) => ({
      ...prev,
      secretKey: value,
    }));
  };

  // Telefon numarası maskeleme - 0 (XXX) XXX XX XX formatı
  const handlePhoneChange = (e) => {
    let value = e.target.value.replace(/\D/g, ""); // Sadece rakamları al

    // Maksimum 11 hane (0 ile başlayan Türkiye formatı)
    if (value.length > 11) {
      value = value.substring(0, 11);
    }

    let formattedValue = "";

    if (value.length > 0) {
      // İlk rakam 0 değilse, 0 ekle
      if (value[0] !== "0") {
        value = "0" + value;
      }

      formattedValue = value[0]; // 0

      if (value.length > 1) {
        formattedValue += " (" + value.substring(1, 4); // 0 (XXX

        if (value.length > 4) {
          formattedValue += ") " + value.substring(4, 7); // 0 (XXX) XXX

          if (value.length > 7) {
            formattedValue += " " + value.substring(7, 9); // 0 (XXX) XXX XX

            if (value.length > 9) {
              formattedValue += " " + value.substring(9, 11); // 0 (XXX) XXX XX XX
            }
          }
        } else if (value.length === 4) {
          formattedValue += ")"; // 0 (XXX)
        }
      }
    }

    setFormData((prev) => ({
      ...prev,
      phone: formattedValue,
    }));
  };

  const toggleGenderDropdown = () => {
    setShowGenderDropdown(!showGenderDropdown);
  };

  const selectGender = (gender) => {
    setFormData((prev) => ({
      ...prev,
      gender: gender,
    }));
    setShowGenderDropdown(false);
  };

  // Date picker fonksiyonları
  const handleDateSelect = (date) => {
    if (date) {
      setSelectedDate(date);
      // GG-AA-YYYY formatına çevir
      const day = date.getDate().toString().padStart(2, "0");
      const month = (date.getMonth() + 1).toString().padStart(2, "0");
      const year = date.getFullYear();
      const formattedDate = `${day}-${month}-${year}`;

      setFormData((prev) => ({
        ...prev,
        birthDate: formattedDate,
      }));
    }
    setShowDatePicker(false);
  };

  // Time picker fonksiyonları
  const handleTimeSelect = (time) => {
    if (time) {
      setSelectedTime(time);
      // HH:MM formatına çevir
      const hours = time.getHours().toString().padStart(2, "0");
      const minutes = time.getMinutes().toString().padStart(2, "0");
      const formattedTime = `${hours}:${minutes}`;

      setFormData((prev) => ({
        ...prev,
        birthTime: formattedTime,
      }));
    }
    setShowTimePicker(false);
  };

  const toggleDatePicker = () => {
    setShowDatePicker(!showDatePicker);
    setShowTimePicker(false);
    setShowGenderDropdown(false);
  };

  const toggleTimePicker = () => {
    setShowTimePicker(!showTimePicker);
    setShowDatePicker(false);
    setShowGenderDropdown(false);
  };

  // Validasyon fonksiyonları
  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  const validatePhone = (phone) => {
    // Sadece rakamları al
    const cleanPhone = phone.replace(/[^0-9]/g, "");
    // Türkiye format kontrolü: 0 ile başlayıp 11 haneli olmalı
    return cleanPhone.length === 11 && cleanPhone.startsWith("0");
  };

  const validateLastName = (name) => {
    return name.trim().length >= 2 && /^[a-zA-ZğüşıöçĞÜŞİÖÇ\s]+$/.test(name);
  };

  const validateBirthDate = (date) => {
    const dateRegex = /^\d{2}-\d{2}-\d{4}$/;
    if (!dateRegex.test(date)) return false;

    // GG-AA-YYYY formatını YYYY-MM-DD formatına çevir
    const [day, month, year] = date.split("-");
    const formattedDate = `${year}-${month}-${day}`;

    const inputDate = new Date(formattedDate);
    const today = new Date();
    const minDate = new Date(today.getFullYear() - 120, 0, 1);

    return inputDate <= today && inputDate >= minDate;
  };

  const validateBirthTime = (time) => {
    const timeRegex = /^([01]?[0-9]|2[0-3]):[0-5][0-9]$/;
    return timeRegex.test(time);
  };

  const validateSecretKey = (key) => {
    return key.length === 4 && /^\d{4}$/.test(key);
  };

  // Konum arama fonksiyonu - Global arama (tüm dünya)
  const searchLocation = async (query) => {
    if (query.length < 2) {
      setLocationResults([]);
      return;
    }

    setIsSearchingLocation(true);
    try {
      // Nominatim API kullanarak global konum arama
      const response = await fetch(
        `https://nominatim.openstreetmap.org/search?format=json&q=${encodeURIComponent(
          query
        )}&limit=15&addressdetails=1&accept-language=tr`
      );
      const data = await response.json();

      // Şehir, kasaba, köy ve idari bölgeleri filtrele
      const filteredResults = data.filter((location) => {
        const locationType = location.type;
        const locationClass = location.class;

        // Şehir, kasaba, köy, ilçe, eyalet gibi yerleşim yerleri
        return (
          locationClass === "place" ||
          locationClass === "boundary" ||
          locationType === "city" ||
          locationType === "town" ||
          locationType === "village" ||
          locationType === "hamlet" ||
          locationType === "municipality" ||
          locationType === "administrative" ||
          locationType === "suburb" ||
          locationType === "quarter"
        );
      });

      // Sonuçları daha detaylı formatta düzenle
      const processedResults = filteredResults.map((location) => {
        let displayName = "";
        let typeLabel = "";

        if (location.address) {
          const {
            city,
            town,
            village,
            state,
            municipality,
            district,
            suburb,
            quarter,
            county,
            country,
          } = location.address;

          // Ana yerleşim adını belirle
          const mainPlace =
            city ||
            town ||
            village ||
            municipality ||
            district ||
            suburb ||
            quarter ||
            county;

          // Detaylı gösterim: "Şehir, Eyalet, Ülke" formatı
          if (mainPlace && state && country) {
            displayName = `${mainPlace}, ${state}, ${country}`;
          } else if (mainPlace && country) {
            displayName = `${mainPlace}, ${country}`;
          } else if (state && country) {
            displayName = `${state}, ${country}`;
          } else {
            // Fallback: orijinal display_name'i kullan ama daha temiz hale getir
            const parts = location.display_name.split(",").map((p) => p.trim());
            displayName = parts.slice(0, 3).join(", ");
          }

          // Tip etiketi
          if (city) typeLabel = "Şehir";
          else if (town) typeLabel = "Kasaba";
          else if (village) typeLabel = "Köy";
          else if (district) typeLabel = "İlçe";
          else if (state) typeLabel = "Eyalet/İl";
          else if (suburb || quarter) typeLabel = "Semt";
          else typeLabel = "Konum";
        } else {
          // Address yoksa display_name'i kullan
          const parts = location.display_name.split(",").map((p) => p.trim());
          displayName = parts.slice(0, 3).join(", ");
          typeLabel = "Konum";
        }

        return {
          ...location,
          simplified_name: displayName,
          display_name: displayName,
          type_label: typeLabel,
        };
      });

      // Dublicate sonuçları kaldır
      const uniqueResults = processedResults.filter(
        (location, index, self) =>
          index ===
          self.findIndex((l) => l.simplified_name === location.simplified_name)
      );

      setLocationResults(uniqueResults.slice(0, 10)); // Maksimum 10 sonuç
    } catch (error) {
      console.error("Konum arama hatası:", error);
      setLocationResults([]);
    } finally {
      setIsSearchingLocation(false);
    }
  };

  const handleLocationSearch = (e) => {
    const value = e.target.value;
    setLocationSearch(value);

    // Önceki timeout'u temizle
    if (searchTimeoutRef.current) {
      clearTimeout(searchTimeoutRef.current);
    }

    // 300ms sonra arama yap (daha hızlı yanıt)
    searchTimeoutRef.current = setTimeout(() => {
      searchLocation(value);
    }, 300);
  };

  const selectLocation = (location) => {
    setSelectedLocation(location);
    const locationName = location.simplified_name || location.display_name;
    setLocationSearch(locationName);
    setLocationResults([]);

    // Form verilerini güncelle
    setFormData((prev) => ({
      ...prev,
      birthPlace: locationName,
    }));
  };

  const handleVerify = async () => {
    if (verificationCode.length !== 6) {
      Notiflix.Notify.failure("Lütfen 6 haneli kodu giriniz.");
      return;
    }
    setVerifyError("");
    setIsVerifying(true);
    try {
      const response = await postPinCode({ uuid, pinCode: verificationCode });
      if (response.isMatch) {
        setScreen(3);
      } else {
        Notiflix.Notify.failure("Doğrulama başarısız. Kodu kontrol edin.");
      }
    } catch (e) {
      Notiflix.Notify.failure("Doğrulama başarısız. Kodu kontrol edin.");
    } finally {
      setIsVerifying(false);
    }
  };

  const handleSubmitForm = () => {
    // Form validation - sadece validasyon yap, API çağrısı yapma
    if (!formData.firstName.trim()) {
      Notiflix.Notify.failure("Lütfen adınızı giriniz.");
      return;
    }

    if (!formData.lastName.trim()) {
      Notiflix.Notify.failure("Lütfen soyadınızı giriniz.");
      return;
    }
    if (!validateLastName(formData.lastName)) {
      Notiflix.Notify.failure(
        "Soyad sadece harf içerebilir ve en az 2 karakter olmalıdır."
      );
      return;
    }
    if (!formData.email.trim()) {
      Notiflix.Notify.failure("Lütfen e-posta adresinizi giriniz.");
      return;
    }
    if (!validateEmail(formData.email)) {
      Notiflix.Notify.failure("Geçerli bir e-posta adresi giriniz.");
      return;
    }
    if (!formData.phone.trim()) {
      Notiflix.Notify.failure("Lütfen telefon numaranızı giriniz.");
      return;
    }
    if (!validatePhone(formData.phone)) {
      Notiflix.Notify.failure("Geçerli bir telefon numarası giriniz.");
      return;
    }
    if (!formData.secretKey.trim()) {
      Notiflix.Notify.failure("Lütfen 4 haneli güvenlik kodunuzu giriniz.");
      return;
    }
    if (!validateSecretKey(formData.secretKey)) {
      Notiflix.Notify.failure("Güvenlik kodu 4 haneli sayısal olmalıdır.");
      return;
    }

    // Validasyon başarılı, bir sonraki ekrana geç
    setScreen(4);
  };

  const handleSubmitProfile = async () => {
    // Form validation
    if (!formData.firstName.trim()) {
      Notiflix.Notify.failure("Lütfen adınızı giriniz.");
      return;
    }

    if (!formData.lastName.trim()) {
      Notiflix.Notify.failure("Lütfen soyadınızı giriniz.");
      return;
    }
    if (!validateLastName(formData.lastName)) {
      Notiflix.Notify.failure(
        "Soyad sadece harf içerebilir ve en az 2 karakter olmalıdır."
      );
      return;
    }
    if (!formData.email.trim()) {
      Notiflix.Notify.failure("Lütfen e-posta adresinizi giriniz.");
      return;
    }
    if (!validateEmail(formData.email)) {
      Notiflix.Notify.failure("Geçerli bir e-posta adresi giriniz.");
      return;
    }
    if (!formData.phone.trim()) {
      Notiflix.Notify.failure("Lütfen telefon numaranızı giriniz.");
      return;
    }
    if (!validatePhone(formData.phone)) {
      Notiflix.Notify.failure("Geçerli bir telefon numarası giriniz.");
      return;
    }
    if (!formData.secretKey.trim()) {
      Notiflix.Notify.failure("Lütfen 4 haneli güvenlik kodunuzu giriniz.");
      return;
    }
    if (!validateSecretKey(formData.secretKey)) {
      Notiflix.Notify.failure("Güvenlik kodu 4 haneli sayısal olmalıdır.");
      return;
    }
    if (!formData.birthDate.trim()) {
      Notiflix.Notify.failure("Lütfen doğum tarihinizi giriniz.");
      return;
    }
    if (!validateBirthDate(formData.birthDate)) {
      Notiflix.Notify.failure(
        "Geçerli bir doğum tarihi giriniz (GG-AA-YYYY formatında)."
      );
      return;
    }
    if (!formData.birthTime.trim()) {
      Notiflix.Notify.failure("Lütfen doğum saatinizi giriniz.");
      return;
    }
    if (!validateBirthTime(formData.birthTime)) {
      Notiflix.Notify.failure(
        "Geçerli bir doğum saati giriniz (HH:MM formatında)."
      );
      return;
    }
    if (!selectedLocation) {
      Notiflix.Notify.failure("Lütfen doğum yerinizi seçiniz.");
      return;
    }

    setSubmitError("");
    setIsSubmitting(true);

    try {
      // GG-AA-YYYY formatını YYYY-MM-DD formatına çevir
      const [day, month, year] = formData.birthDate.split("-");
      const formattedBirthDate = `${year}-${month}-${day}`;
      const randomPassword = generateRandomPassword();

      const submitData = {
        uuid: uuid,
        first_name: formData.firstName,
        last_name: formData.lastName,
        email: formData.email,
        gender: formData.gender === "Erkek" ? "male" : "female",
        phone: formData.phone.replace(/[^0-9]/g, ""), // Sadece rakamları gönder
        password: randomPassword,
        birth_date: formattedBirthDate,
        latitude: parseFloat(selectedLocation.lat),
        longitude: parseFloat(selectedLocation.lon),
        birth_time: formData.birthTime,
        birth_place: selectedLocation.display_name,
        pinCode: verificationCode,
        secret_key: formData.secretKey,
      };

      const response = await postCreateProfile(submitData);

      const response2 = await userLoginWithSecret(
        formData.email,
        formData.secretKey
      );
      setCookie(response2);

      setScreen(5);
    } catch (e) {
      setSubmitError(
        "Profil oluşturulurken hata oluştu. Lütfen tekrar deneyin."
      );
      console.error("Profil oluşturma hatası:", e);
    } finally {
      setIsSubmitting(false);
    }
  };

  // Animasyon varyantları
  const pageVariants = {
    initial: {
      opacity: 0,
      scale: 0.95,
    },
    animate: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.3,
        ease: "easeOut",
      },
    },
    exit: {
      opacity: 0,
      scale: 0.95,
      transition: {
        duration: 0.2,
        ease: "easeIn",
      },
    },
  };

  const buttonVariants = {
    initial: { scale: 1 },
    hover: {
      scale: 1.02,
      boxShadow: "0 8px 25px rgba(0,0,0,0.15)",
      transition: { duration: 0.2 },
    },
    tap: {
      scale: 0.98,
      transition: { duration: 0.1 },
    },
  };

  const overlayVariants = {
    hidden: {
      opacity: 0,
      scale: 0.8,
    },
    visible: {
      opacity: 1,
      scale: 1,
      transition: {
        duration: 0.5,
        ease: "easeOut",
      },
    },
  };

  return (
    <>
      <style jsx>{`
        * {
          margin: 0;
          padding: 0;
          box-sizing: border-box;
        }

        html,
        body {
          height: 100%;
          overflow: hidden;
        }

        /* DatePicker Custom Styles */
        .custom-datepicker {
          font-family: "Poppins", sans-serif !important;
          font-size: 14px !important;
        }

        .custom-datepicker .react-datepicker__header {
          background-color: #f8f9fa !important;
          border-bottom: 1px solid #e9ecef !important;
        }

        .custom-datepicker .react-datepicker__current-month {
          color: #495057 !important;
          font-weight: 600 !important;
        }

        .custom-datepicker .react-datepicker__day--selected {
          background-color: #3b82f6 !important;
          border-radius: 50% !important;
        }

        .custom-datepicker .react-datepicker__day:hover {
          background-color: #e3f2fd !important;
          border-radius: 50% !important;
        }

        .custom-timepicker {
          font-family: "Poppins", sans-serif !important;
          font-size: 14px !important;
        }

        .custom-timepicker .react-datepicker__time-container {
          width: 100% !important;
        }

        .custom-timepicker .react-datepicker__time-list-item--selected {
          background-color: #3b82f6 !important;
          color: white !important;
        }

        .custom-timepicker .react-datepicker__time-list-item:hover {
          background-color: #e3f2fd !important;
        }

        .full-viewport {
          position: fixed !important;
          top: 0 !important;
          left: 0 !important;
          width: 100vw !important;
          height: 100vh !important;
          height: 100dvh !important;
          margin: 0 !important;
          padding: 0 !important;
          overflow: hidden !important;
        }

        .screen-container {
          position: absolute !important;
          top: 0 !important;
          left: 0 !important;
          width: 100% !important;
          height: 100% !important;
          overflow-y: auto !important;
          overflow-x: hidden !important;
        }

        @media (min-width: 640px) {
          .full-viewport {
            position: relative !important;
            width: auto !important;
            height: auto !important;
            overflow: visible !important;
          }

          .screen-container {
            position: relative !important;
            overflow: visible !important;
          }
        }
      `}</style>
      <div className="full-viewport flex items-stretch justify-stretch sm:items-center sm:justify-center bg-[#e8e9ed]">
        <AnimatePresence mode="wait">
          {screen === 1 && (
            <motion.div
              key="screen1"
              variants={pageVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              className="screen-container flex flex-col items-center w-full bg-white shadow-xl border border-gray-200 rounded-none sm:max-w-[390px] sm:h-[700px] sm:rounded-3xl relative"
              style={{
                backgroundImage: "url(/assets/pngImages/welcomeScreen.png)",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            >
              <Header activeStep={1} />
              <div className="flex flex-col items-center justify-between w-full flex-1 relative">
                <div className="text-center w-full px-6">
                  <h1 className="text-[27px] mt-8 md:mt-0 xl:mt-3 font-poppins text-white pb-2">
                    Hoş Geldiniz
                  </h1>
                  <h2 className="text-md text-[#EBEAEC]">
                    Sizi burada görmekten büyük mutluluk <br /> duyuyoruz!
                  </h2>
                </div>

                <div className="relative w-full flex-1 flex items-end">
                  <img
                    src="/assets/pngImages/jodiacWelcomeImg.png"
                    alt="Jodiac Logo"
                    className="w-full mt-0 md:mt-12 xl:mt-16 h-auto hover:scale-105 transition-transform duration-300 object-cover"
                  />
                  <div className="absolute bottom-16 sm:bottom-12 md:bottom-20 xl:bottom-28 left-4 right-4 sm:left-6 sm:right-6">
                    <motion.button
                      variants={buttonVariants}
                      initial="initial"
                      whileHover="hover"
                      whileTap="tap"
                      onClick={() => setScreen(2)}
                      className="w-full bg-white h-14 sm:h-16 text-black font-semibold py-3 rounded-full shadow transition text-[12px] sm:text-[14px]"
                    >
                      DEVAM ET
                    </motion.button>
                  </div>
                </div>
              </div>
            </motion.div>
          )}
          {screen === 2 && (
            <motion.div
              key="screen2"
              variants={pageVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              className="screen-container flex flex-col items-center w-full bg-white shadow-xl border border-gray-200 rounded-none sm:max-w-[390px] sm:h-[700px] sm:rounded-3xl relative"
              style={{
                backgroundImage: "url(/assets/pngImages/welcomeScreen.png)",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            >
              <Header activeStep={2} />
              <div className="flex flex-col items-center justify-center p-6 w-full">
                <div className="text-center">
                  <h1 className="text-[26px] font-poppins mb-2 text-white pt-12 pb-2">
                    Doğrulama
                  </h1>
                  <h2 className="text-[16px] mb-8 text-white">
                    Size verilen 6 haneli pin kodunu giriniz.
                  </h2>
                  <motion.div
                    className="flex justify-center w-full max-w-[343px] mb-6 mx-auto"
                    initial={{ opacity: 0, y: 20 }}
                    animate={{ opacity: 1, y: 0 }}
                    transition={{ delay: 0.3 }}
                  >
                    <motion.input
                      type="text"
                      inputMode="numeric"
                      maxLength={6}
                      value={verificationCode}
                      onChange={handlePinChange}
                      placeholder="000000"
                      className="w-full h-16 rounded-2xl text-center text-3xl font-bold tracking-[0.8em] border-2 border-gray-300 focus:outline-none focus:ring-4 focus:ring-blue-400 focus:border-blue-500 bg-white text-gray-800 placeholder:text-gray-300 transition-all duration-300 shadow-lg"
                      initial={{ scale: 0.9, opacity: 0 }}
                      animate={{ scale: 1, opacity: 1 }}
                      transition={{ delay: 0.4 }}
                      whileFocus={{
                        scale: 1.02,
                        borderColor: "#3B82F6",
                        boxShadow:
                          "0 0 0 4px rgba(59, 130, 246, 0.15), 0 10px 25px rgba(0, 0, 0, 0.1)",
                      }}
                      style={{
                        letterSpacing:
                          verificationCode.length > 0 ? "0.8em" : "normal",
                        paddingLeft:
                          verificationCode.length > 0 ? "0.4em" : "0",
                      }}
                    />
                  </motion.div>
                  <motion.button
                    variants={buttonVariants}
                    initial="initial"
                    whileHover="hover"
                    whileTap="tap"
                    onClick={handleVerify}
                    disabled={isVerifying}
                    className="w-full h-14 sm:h-16 mt-8 sm:mt-12 bg-white text-black font-semibold py-3 rounded-full shadow transition text-[12px] sm:text-[14px] disabled:opacity-60 disabled:cursor-not-allowed"
                  >
                    {isVerifying ? "DOĞRULANIYOR..." : "DOĞRULA"}
                  </motion.button>
                  {verifyError && (
                    <p className="text-red-200 text-xs mt-3">{verifyError}</p>
                  )}
                </div>
              </div>
            </motion.div>
          )}
          {screen === 3 && (
            <motion.div
              key="screen3"
              variants={pageVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              className="screen-container flex flex-col items-center w-full bg-white shadow-xl border border-gray-200 rounded-none sm:max-w-[390px] sm:h-[700px] sm:rounded-3xl relative"
              style={{
                backgroundImage: "url(/assets/pngImages/welcomeScreen.png)",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            >
              <Header activeStep={3} />
              <div className="flex flex-col items-center justify-center p-6 w-full">
                <div className="text-center">
                  <h1 className="text-[16px] font-poppins text-white leading-8 mb-1">
                    Üyelik Bilgileri
                  </h1>
                  <h2 className="text-sm md:mb-0 xl:mb-8 text-[#EBEAEC]">
                    Temel bilgilerinizi girebilirsiniz.
                  </h2>
                  <div className="flex flex-col justify-center gap-2 w-full mt-4 md:mt-4 xl:mt-4">
                    <div className="flex space-x-4">
                      <input
                        type="text"
                        name="firstName"
                        placeholder="İsim"
                        value={formData.firstName}
                        onChange={handleInputChange}
                        className="placeholder:text-[#ADB3BC] w-[160px] text-[14px] font-poppins h-12 rounded-full text-left pl-5 text-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white"
                      />
                      <input
                        type="text"
                        name="lastName"
                        placeholder="Soyisim"
                        value={formData.lastName}
                        onChange={handleInputChange}
                        className="placeholder:text-[#ADB3BC] w-[160px] text-[14px] font-poppins h-12 rounded-full text-left pl-5 text-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white"
                      />
                    </div>
                    <input
                      type="email"
                      name="email"
                      placeholder="E-Posta"
                      value={formData.email}
                      onChange={handleInputChange}
                      className="placeholder:text-[#ADB3BC] text-[14px] font-poppins w-full h-12 rounded-full text-left pl-5 text-md px-16 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white"
                    />
                    <div className="w-full">
                      <input
                        type="tel"
                        name="phone"
                        placeholder="Telefon Numarası "
                        value={formData.phone}
                        onChange={handlePhoneChange}
                        maxLength={17}
                        className="placeholder:text-[#ADB3BC] text-[14px] font-poppins w-full h-12 rounded-full text-left pl-5 text-md px-16 border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white"
                      />
                    </div>
                    <hr className="my-2 border-t border-white" />
                    <p className="text-xs text-white mb-2">
                      Bu 4 haneli gizli anahtarı unutmayın. Uygulamaya giriş
                      yaparken kullanacaksınız.
                    </p>
                    <input
                      type="text"
                      name="secretKey"
                      placeholder="4 Haneli Gizli Kodunuzu Belirleyin"
                      value={formData.secretKey}
                      onChange={handleSecretKeyChange}
                      maxLength={4}
                      className="placeholder:text-[#ADB3BC] text-[14px] font-poppins w-full h-12 rounded-full text-left pl-5 text-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white"
                    />
                  </div>
                </div>
                <motion.button
                  variants={buttonVariants}
                  initial="initial"
                  whileHover="hover"
                  whileTap="tap"
                  onClick={handleSubmitForm}
                  disabled={isSubmitting}
                  className="font-poppins w-full h-14 sm:h-16 bg-white mt-2 sm:mt-16 md:mt-0 xl:mt-0 text-black font-semibold py-3 rounded-full shadow transition text-[12px] sm:text-[14px] disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  {isSubmitting ? "KAYDEDİLİYOR..." : "DEVAM ET"}
                </motion.button>
                {submitError && (
                  <p className="text-red-200 text-xs mt-3 text-center">
                    {submitError}
                  </p>
                )}
              </div>
            </motion.div>
          )}
          {screen === 4 && (
            <motion.div
              key="screen4"
              variants={pageVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              className="screen-container flex flex-col items-center w-full bg-white shadow-xl border border-gray-200 rounded-none sm:max-w-[390px] sm:h-[700px] sm:rounded-3xl relative"
              style={{
                backgroundImage: "url(/assets/pngImages/welcomeScreen.png)",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            >
              <Header activeStep={4} />
              <div className="flex flex-col items-center justify-center p-6 w-full">
                <div className="text-center">
                  <h1 className="text-[20px] font-poppins text-white leading-8 mb-1">
                    Üyelik Bilgileri
                  </h1>
                  <h2 className="text-sm md:mb-5 xl:mb-8 text-[#EBEAEC]">
                    Son adım olarak doğum haritanızı <br /> oluşturmamız için
                    istenilen bilgileri giriniz.
                  </h2>
                  <div className="flex flex-col justify-center gap-2 mb-6 w-full mt-12 md:mt-4 xl:mt-4">
                    <div className="relative w-[343px]" ref={datePickerRef}>
                      <input
                        type="text"
                        name="birthDate"
                        placeholder="Doğum Tarihi (GG-AA-YYYY)"
                        value={formData.birthDate}
                        onChange={handleBirthDateChange}
                        maxLength={10}
                        className="placeholder:text-[#ADB3BC] w-full text-[14px] text-black font-poppins h-12 rounded-full text-left pl-12 pr-5 text-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white"
                      />
                      <button
                        type="button"
                        onClick={toggleDatePicker}
                        className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
                      >
                        <MdCalendarToday className="text-lg" />
                      </button>
                      {showDatePicker && (
                        <div className="absolute top-full left-0 mt-1 z-50 bg-white border border-gray-300 rounded-lg shadow-lg">
                          <DatePicker
                            selected={selectedDate}
                            onChange={handleDateSelect}
                            locale="tr"
                            dateFormat="dd-MM-yyyy"
                            maxDate={new Date()}
                            minDate={
                              new Date(new Date().getFullYear() - 120, 0, 1)
                            }
                            showYearDropdown
                            yearDropdownItemNumber={120}
                            scrollableYearDropdown
                            placeholderText="Tarih seçin"
                            inline
                            calendarClassName="custom-datepicker"
                          />
                        </div>
                      )}
                    </div>
                    <div className="relative w-full" ref={timePickerRef}>
                      <input
                        type="text"
                        name="birthTime"
                        placeholder="Doğum Saati (ÖR: 14:30)"
                        maxLength={5}
                        value={formData.birthTime}
                        onChange={handleBirthTimeChange}
                        className="placeholder:text-[#ADB3BC] text-[14px] font-poppins w-full h-12 rounded-full text-left pl-12 pr-5 text-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white"
                      />
                      <button
                        type="button"
                        onClick={toggleTimePicker}
                        className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600 transition-colors"
                      >
                        <MdAccessTime className="text-lg" />
                      </button>
                      {showTimePicker && (
                        <div className="absolute top-full left-0 mt-1 z-50 bg-white border border-gray-300 rounded-lg shadow-lg p-4">
                          <DatePicker
                            selected={selectedTime}
                            onChange={handleTimeSelect}
                            showTimeSelect
                            showTimeSelectOnly
                            timeIntervals={15}
                            timeCaption="Saat"
                            dateFormat="HH:mm"
                            timeFormat="HH:mm"
                            placeholderText="Saat seçin"
                            inline
                            calendarClassName="custom-timepicker"
                          />
                        </div>
                      )}
                    </div>
                    <div className="relative w-full">
                      <input
                        type="text"
                        placeholder="Doğum Yeri Ara (Şehir, Ülke)"
                        value={locationSearch}
                        onChange={handleLocationSearch}
                        className="placeholder:text-[#ADB3BC] text-[14px] font-poppins w-full h-12 rounded-full text-left pl-5 text-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white"
                      />
                      {isSearchingLocation && (
                        <div className="absolute right-3 top-1/2 transform -translate-y-1/2">
                          <div className="animate-spin rounded-full h-4 w-4 border-b-2 border-blue-500"></div>
                        </div>
                      )}
                      {locationResults.length > 0 && (
                        <div className="absolute top-full left-0 right-0 mt-1 bg-white border border-gray-300 rounded-lg shadow-lg z-50 max-h-64 overflow-y-auto">
                          {locationResults.map((location, index) => (
                            <button
                              key={index}
                              onClick={() => selectLocation(location)}
                              className="w-full text-left px-4 py-3 hover:bg-blue-50 transition-colors duration-150 border-b border-gray-100 last:border-b-0 group"
                            >
                              <div className="font-medium text-gray-800 group-hover:text-blue-600 transition-colors">
                                {location.simplified_name ||
                                  location.display_name}
                              </div>
                              <div className="flex items-center gap-2 mt-1">
                                <span className="text-xs text-white bg-blue-500 px-2 py-0.5 rounded-full font-medium">
                                  {location.type_label || "Konum"}
                                </span>
                                {location.address?.country && (
                                  <span className="text-xs text-gray-500">
                                    {location.address.country}
                                  </span>
                                )}
                              </div>
                            </button>
                          ))}
                        </div>
                      )}
                    </div>
                    <div
                      className="relative w-[343px] sm:w-full"
                      ref={genderDropdownRef}
                    >
                      <button
                        type="button"
                        onClick={toggleGenderDropdown}
                        className="w-full h-12 rounded-full text-left pl-5 pr-5 text-md border border-gray-300 focus:outline-none focus:ring-2 focus:ring-blue-400 bg-white text-[#565656] font-poppins text-[14px] flex items-center justify-between"
                      >
                        <span>{formData.gender}</span>
                        <svg
                          className={`w-4 h-4 transition-transform duration-200 ${
                            showGenderDropdown ? "rotate-180" : ""
                          }`}
                          fill="none"
                          stroke="currentColor"
                          viewBox="0 0 24 24"
                        >
                          <path
                            strokeLinecap="round"
                            strokeLinejoin="round"
                            strokeWidth={2}
                            d="M19 9l-7 7-7-7"
                          />
                        </svg>
                      </button>

                      {showGenderDropdown && (
                        <motion.div
                          initial={{ opacity: 0, y: -10 }}
                          animate={{ opacity: 1, y: 0 }}
                          exit={{ opacity: 0, y: -10 }}
                          transition={{ duration: 0.2 }}
                          className="absolute z-50 w-full mt-1 bg-white border border-gray-300 rounded-2xl shadow-lg overflow-hidden"
                        >
                          <button
                            type="button"
                            onClick={() => selectGender("Kadın")}
                            className={`w-full px-5 py-3 text-left text-[14px] font-poppins hover:bg-gray-50 transition-colors ${
                              formData.gender === "Kadın"
                                ? "bg-blue-50 text-blue-600"
                                : "text-[#565656]"
                            }`}
                          >
                            Kadın
                          </button>

                          <button
                            type="button"
                            onClick={() => selectGender("Erkek")}
                            className={`w-full px-5 py-3 text-left text-[14px] font-poppins hover:bg-gray-50 transition-colors ${
                              formData.gender === "Erkek"
                                ? "bg-blue-50 text-blue-600"
                                : "text-[#565656]"
                            }`}
                          >
                            Erkek
                          </button>
                        </motion.div>
                      )}
                    </div>
                  </div>
                </div>
                <motion.button
                  variants={buttonVariants}
                  initial="initial"
                  whileHover="hover"
                  whileTap="tap"
                  onClick={handleSubmitProfile}
                  disabled={isSubmitting}
                  className="font-poppins w-full h-14 sm:h-16 bg-white mt-12 sm:mt-16 md:mt-0 xl:mt-0 text-black font-semibold py-3 rounded-full shadow transition text-[12px] sm:text-[14px] disabled:opacity-60 disabled:cursor-not-allowed"
                >
                  {isSubmitting ? "PROFİL OLUŞTURULUYOR..." : "DEVAM ET"}
                </motion.button>
                {submitError && (
                  <p className="text-red-200 text-xs mt-3 text-center">
                    {submitError}
                  </p>
                )}
              </div>
            </motion.div>
          )}
          {screen === 5 && (
            <motion.div
              key="screen5"
              variants={pageVariants}
              initial="initial"
              animate="animate"
              exit="exit"
              className="screen-container flex flex-col items-center w-full shadow-xl border border-gray-200 rounded-none sm:max-w-[390px] sm:h-[700px] sm:rounded-3xl relative overflow-hidden"
              style={{
                backgroundImage: "url(/assets/pngImages/welcomeScreen.png)",
                backgroundSize: "cover",
                backgroundPosition: "center",
                backgroundRepeat: "no-repeat",
              }}
            >
              <Header activeStep={5} />
              <div className="flex flex-col items-center justify-center p-6 w-full h-full">
                {/* Success Icon */}
                <motion.div
                  initial={{ scale: 0 }}
                  animate={{ scale: 1 }}
                  transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
                  className="mb-8"
                >
                  <div className="w-32 h-32 bg-gradient-to-br from-[#3DA7B5] to-[#5ABCC8] rounded-full flex items-center justify-center shadow-2xl">
                    <svg
                      className="w-16 h-16 text-white"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                    >
                      <motion.path
                        initial={{ pathLength: 0 }}
                        animate={{ pathLength: 1 }}
                        transition={{ delay: 0.5, duration: 0.5 }}
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={3}
                        d="M5 13l4 4L19 7"
                      />
                    </svg>
                  </div>
                </motion.div>

                {/* Title */}
                <motion.h1
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.4 }}
                  className="text-[32px] text-center font-spicy-rice text-white leading-tight mb-4"
                >
                  Hazırsın!
                </motion.h1>

                {/* Description */}
                <motion.div
                  initial={{ opacity: 0, y: 20 }}
                  animate={{ opacity: 1, y: 0 }}
                  transition={{ delay: 0.6 }}
                  className="mb-12"
                >
                  <p className="text-base text-white/90 text-center max-w-xs leading-relaxed">
                    Yolculuğuna başlamaya hazırsın! Şimdi kişisel gelişim ve
                    keşif yolculuğuna başlayabilirsin.
                  </p>
                </motion.div>

                {/* Start Button */}
                <motion.button
                  variants={buttonVariants}
                  initial="initial"
                  whileHover="hover"
                  whileTap="tap"
                  onClick={() => navigate("/" + uuid)}
                  className="w-full max-w-xs h-14 sm:h-16 bg-white text-[#3DA7B5] font-bold py-3 rounded-full shadow-2xl transition text-base sm:text-lg"
                >
                  BAŞLA
                </motion.button>
              </div>
            </motion.div>
          )}
        </AnimatePresence>
      </div>
    </>
  );
}
